import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { Close, Check } from "@element-plus/icons-vue";
import { computed, reactive, watch, onMounted } from "vue";
export default {
  props: ["questionInfo", "allAnswers"],
  setup(props, content) {
    //处理题目
    let itemText = computed(() => {
      let text = props.questionInfo.itemText;
      return text;
    });
    //答案
    let answer = reactive({});
    watch(props, () => {
      let list = {};
      props.questionInfo.questionGroupList.forEach(questionGroup => {
        questionGroup.questionList.forEach(questionItem => {
          list[questionItem.questionId] = props.allAnswers && props.allAnswers[questionItem.questionId] ? props.allAnswers[questionItem.questionId] : "";
          list[questionItem.questionId] = props.allAnswers && props.allAnswers[questionItem.questionId] ? props.allAnswers[questionItem.questionId].split(",") : [];
        });
      });
      for (let key in answer) {
        delete answer[key];
      }
      Object.assign(answer, list);
      setAnswer();
    }, {
      immediate: true
    });
    //更换题目
    watch(() => props.questionInfo, () => {
      document.getElementsByClassName("question-text")[0].scrollTop = 0;
      document.getElementsByClassName("answer")[0].scrollTop = 0;
      setAnswer();
    });
    onMounted(() => {
      setAnswer();
    });
    function setAnswer() {
      let data = {};
      for (let key in answer) {
        if (answer[key] instanceof Array) {
          let arr = [...answer[key]];
          data[key] = arr.sort((x, y) => {
            return x.charCodeAt() - y.charCodeAt();
          }).join(",");
        } else {
          data[key] = answer[key];
        }
      }
      content.emit("setAnswer", data);
    }
    return {
      itemText,
      answer,
      setAnswer,
      Close,
      Check
    };
  }
};